/**
 * Экран отказа хранилища.
 *
 * Показывается вместо приложения, когда база не открылась. Раньше в этом
 * случае человек видел бесконечные скелетоны: приложение выглядело работающим,
 * но пустым, и естественный вывод был «я потерял всё».
 *
 * Поэтому экран говорит три вещи: что случилось, целы ли данные и что сделать.
 */

import { DatabaseZap, RefreshCw } from 'lucide-react';

import type { StorageProblem } from '@/shared/db/storage-health';
import { Button } from '@/shared/ui/Button';

export function StorageProblemScreen({ problem }: { problem: StorageProblem }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center">
      <span
        className="flex size-14 items-center justify-center rounded-lg bg-warning-soft text-warning"
        aria-hidden
      >
        <DatabaseZap size={26} />
      </span>

      <h1 className="text-[20px] font-semibold">{problem.title}</h1>
      <p className="max-w-sm text-[15px] text-muted">{problem.description}</p>
      <p className="max-w-sm text-[14px]">{problem.hint}</p>

      <Button
        size="lg"
        iconLeft={<RefreshCw size={18} aria-hidden />}
        onClick={() => window.location.reload()}
      >
        Обновить страницу
      </Button>
    </div>
  );
}
